import * as React from 'react';
import { IndexRoute, Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import MyPurchasesApp from 'bundles/my-purchases-graphql/components/MyPurchasesApp';

const ManageSubscriptionsTab = loadOnRoute(
  () => import('bundles/my-purchases-graphql/components/tabs/ManageSubscriptionsTab')
);
const ConfirmationError = loadOnRoute(
  () => import('bundles/my-purchases-graphql/components/refunds/ConfirmationError')
);
const ConfirmationSuccess = loadOnRoute(
  () => import('bundles/my-purchases-graphql/components/refunds/ConfirmationSuccess')
);
const GetRefundPage = loadOnRoute(() => import('bundles/my-purchases-graphql/components/refunds/GetRefundPage'));
const RefundWizard = loadOnRoute(() => import('bundles/my-purchases-graphql/components/refunds/RefundWizard'));
const TrackRefund = loadOnRoute(() => import('bundles/my-purchases-graphql/components/refunds/TrackRefund'));
const FinancialAidTab = loadOnRoute(() => import('bundles/my-purchases-graphql/components/tabs/FinancialAidTab'));
const NotFound = loadOnRoute(() => import('bundles/phoenix/components/NotFound'));
const TransactionsTab = loadOnRoute(() => import('bundles/my-purchases-graphql/components/tabs/TransactionsTab'));

export default (
  <CourseraRoute
    path="/my-purchases"
    component={MyPurchasesApp}
    handle={{
      tracking: { data: () => ({ page: { type: 'my_purchases' } }) },
    }}
  >
    <IndexRoute getComponent={ManageSubscriptionsTab} />
    <Route path="transactions" getComponent={TransactionsTab} />
    <Route path="subscriptions" getComponent={ManageSubscriptionsTab} />
    <Route path="financial-aid" getComponent={FinancialAidTab} />
    <Route path="track-refund/:userProductTransactionId/:cartId" getComponent={TrackRefund} />
    <Route path="get-refund/:userProductTransactionId/:cartId/success" getComponent={ConfirmationSuccess} />
    <Route path="get-refund/error" getComponent={ConfirmationError} />
    <Route path="get-refund/:userProductTransactionId/:cartId" getComponent={GetRefundPage} />
    <Route path="get-refund-survey" getComponent={RefundWizard} />
    <Route path="*" getComponent={NotFound} />
  </CourseraRoute>
);
